import { Component, Input } from '@angular/core';
import { AmdSidenavService } from './sidenav.service';
export class AmdSidenavComponent {
    /**
     * @param {?} amdSidenavService
     */
    constructor(amdSidenavService) {
        this.amdSidenavService = amdSidenavService;
        this.isOpen = false;
        this.amdSidenavService.sidenavToggled.subscribe((sidenavId) => {
            if (sidenavId === this.sidenavId) {
                this.toggleSidenav();
            }
        });
        this.amdSidenavService.sidenavOpened.subscribe((sidenavId) => {
            if (sidenavId === this.sidenavId) {
                this.openSidenav();
            }
        });
        this.amdSidenavService.sidenavClosed.subscribe((sidenavId) => {
            if (sidenavId === this.sidenavId) {
                this.closeSidenav();
            }
        });
    }
    /**
     * @return {?}
     */
    toggleSidenav() {
        this.isOpen = !this.isOpen;
    }
    /**
     * @return {?}
     */
    openSidenav() {
        this.isOpen = true;
    }
    /**
     * @return {?}
     */
    closeSidenav() {
        this.isOpen = false;
    }
}
AmdSidenavComponent.decorators = [
    { type: Component, args: [{
                selector: 'amd-sidenav',
                template: "<div class=\"amd-sidenav\" [class.isOpen]=\"isOpen\"> <div class=\"amd-sidenav-backdrop\" (click)=\"closeSidenav()\"></div> <div class=\"amd-sidenav-content\"> <ng-content></ng-content> </div> </div>"
            },] },
];
/**
 * @nocollapse
 */
AmdSidenavComponent.ctorParameters = () => [
    { type: AmdSidenavService, },
];
AmdSidenavComponent.propDecorators = {
    'sidenavId': [{ type: Input },],
};
function AmdSidenavComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdSidenavComponent.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdSidenavComponent.ctorParameters;
    /** @type {?} */
    AmdSidenavComponent.propDecorators;
    /** @type {?} */
    AmdSidenavComponent.prototype.sidenavId;
    /** @type {?} */
    AmdSidenavComponent.prototype.isOpen;
    /** @type {?} */
    AmdSidenavComponent.prototype.amdSidenavService;
}
//# sourceMappingURL=sidenav.component.js.map
//# sourceMappingURL=sidenav.component.js.map
